// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BenzoRouteImport } from './routes/benzo'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as HarmReductionRouteImport } from './routes/harm-reduction'
import { Route as MatrixRouteImport } from './routes/matrix'
import { Route as MedcanRouteImport } from './routes/medcan'
import { Route as NotfallRouteImport } from './routes/notfall'
import { Route as OpioideRouteImport } from './routes/opioide'
import { Route as TerpeneRouteImport } from './routes/terpene'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/_admin'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as HarmReductionSlugRouteImport } from './routes/harm-reduction_.$slug'
import { Route as MatrixPairRouteImport } from './routes/matrix_.$pair'
import { Route as AuthenticatedAdminAdminRouteImport } from './routes/_authenticated/_admin/admin'
import { Route as AuthenticatedAdminAdminAiQueriesRouteImport } from './routes/_authenticated/_admin/admin.ai-queries'
import { Route as AuthenticatedAdminAdminMatrixRouteImport } from './routes/_authenticated/_admin/admin.matrix'
import { Route as AuthenticatedAdminAdminBenzoNewRouteImport } from './routes/_authenticated/_admin/admin.benzo.new'
import { Route as AuthenticatedAdminAdminBlogNewRouteImport } from './routes/_authenticated/_admin/admin.blog.new'
import { Route as AuthenticatedAdminAdminHarmReductionNewRouteImport } from './routes/_authenticated/_admin/admin.harm-reduction.new'
import { Route as AuthenticatedAdminAdminMedcanNewRouteImport } from './routes/_authenticated/_admin/admin.medcan.new'
import { Route as AuthenticatedAdminAdminOpioideNewRouteImport } from './routes/_authenticated/_admin/admin.opioide.new'
import { Route as AuthenticatedAdminAdminSourcesIndexRouteImport } from './routes/_authenticated/_admin/admin.sources.index'
import { Route as AuthenticatedAdminAdminSourcesNewRouteImport } from './routes/_authenticated/_admin/admin.sources.new'
import { Route as AuthenticatedAdminAdminSubstancesNewRouteImport } from './routes/_authenticated/_admin/admin.substances.new'
import { Route as AuthenticatedAdminAdminBenzoIdEditRouteImport } from './routes/_authenticated/_admin/admin.benzo.$id.edit'
import { Route as AuthenticatedAdminAdminBlogIdEditRouteImport } from './routes/_authenticated/_admin/admin.blog.$id.edit'
import { Route as AuthenticatedAdminAdminHarmReductionIdEditRouteImport } from './routes/_authenticated/_admin/admin.harm-reduction.$id.edit'
import { Route as AuthenticatedAdminAdminMedcanIdEditRouteImport } from './routes/_authenticated/_admin/admin.medcan.$id.edit'
import { Route as AuthenticatedAdminAdminOpioideIdEditRouteImport } from './routes/_authenticated/_admin/admin.opioide.$id.edit'
import { Route as AuthenticatedAdminAdminSourcesIdEditRouteImport } from './routes/_authenticated/_admin/admin.sources.$id.edit'
import { Route as AuthenticatedAdminAdminSubstancesIdEditRouteImport } from './routes/_authenticated/_admin/admin.substances.$id.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BenzoRoute = BenzoRouteImport.update({
            id: '/benzo',path: '/benzo',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const HarmReductionRoute = HarmReductionRouteImport.update({
            id: '/harm-reduction',path: '/harm-reduction',getParentRoute: () => rootRouteImport
          })
const MatrixRoute = MatrixRouteImport.update({
            id: '/matrix',path: '/matrix',getParentRoute: () => rootRouteImport
          })
const MedcanRoute = MedcanRouteImport.update({
            id: '/medcan',path: '/medcan',getParentRoute: () => rootRouteImport
          })
const NotfallRoute = NotfallRouteImport.update({
            id: '/notfall',path: '/notfall',getParentRoute: () => rootRouteImport
          })
const OpioideRoute = OpioideRouteImport.update({
            id: '/opioide',path: '/opioide',getParentRoute: () => rootRouteImport
          })
const TerpeneRoute = TerpeneRouteImport.update({
            id: '/terpene',path: '/terpene',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/_admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog_/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const HarmReductionSlugRoute = HarmReductionSlugRouteImport.update({
            id: '/harm-reduction_/$slug',path: '/harm-reduction/$slug',getParentRoute: () => rootRouteImport
          })
const MatrixPairRoute = MatrixPairRouteImport.update({
            id: '/matrix_/$pair',path: '/matrix/$pair',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminAdminRoute = AuthenticatedAdminAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAdminAiQueriesRoute = AuthenticatedAdminAdminAiQueriesRouteImport.update({
            id: '/ai-queries',path: '/ai-queries',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminMatrixRoute = AuthenticatedAdminAdminMatrixRouteImport.update({
            id: '/matrix',path: '/matrix',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminBenzoNewRoute = AuthenticatedAdminAdminBenzoNewRouteImport.update({
            id: '/benzo/new',path: '/benzo/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminBlogNewRoute = AuthenticatedAdminAdminBlogNewRouteImport.update({
            id: '/blog/new',path: '/blog/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminHarmReductionNewRoute = AuthenticatedAdminAdminHarmReductionNewRouteImport.update({
            id: '/harm-reduction/new',path: '/harm-reduction/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminMedcanNewRoute = AuthenticatedAdminAdminMedcanNewRouteImport.update({
            id: '/medcan/new',path: '/medcan/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminOpioideNewRoute = AuthenticatedAdminAdminOpioideNewRouteImport.update({
            id: '/opioide/new',path: '/opioide/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminSourcesIndexRoute = AuthenticatedAdminAdminSourcesIndexRouteImport.update({
            id: '/sources/',path: '/sources/',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminSourcesNewRoute = AuthenticatedAdminAdminSourcesNewRouteImport.update({
            id: '/sources/new',path: '/sources/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminSubstancesNewRoute = AuthenticatedAdminAdminSubstancesNewRouteImport.update({
            id: '/substances/new',path: '/substances/new',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminBenzoIdEditRoute = AuthenticatedAdminAdminBenzoIdEditRouteImport.update({
            id: '/benzo/$id/edit',path: '/benzo/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminBlogIdEditRoute = AuthenticatedAdminAdminBlogIdEditRouteImport.update({
            id: '/blog/$id/edit',path: '/blog/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminHarmReductionIdEditRoute = AuthenticatedAdminAdminHarmReductionIdEditRouteImport.update({
            id: '/harm-reduction/$id/edit',path: '/harm-reduction/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminMedcanIdEditRoute = AuthenticatedAdminAdminMedcanIdEditRouteImport.update({
            id: '/medcan/$id/edit',path: '/medcan/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminOpioideIdEditRoute = AuthenticatedAdminAdminOpioideIdEditRouteImport.update({
            id: '/opioide/$id/edit',path: '/opioide/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminSourcesIdEditRoute = AuthenticatedAdminAdminSourcesIdEditRouteImport.update({
            id: '/sources/$id/edit',path: '/sources/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })
const AuthenticatedAdminAdminSubstancesIdEditRoute = AuthenticatedAdminAdminSubstancesIdEditRouteImport.update({
            id: '/substances/$id/edit',path: '/substances/$id/edit',getParentRoute: () => AuthenticatedAdminAdminRoute
          })





const AuthenticatedAdminAdminRouteChildren = {
  AuthenticatedAdminAdminAiQueriesRoute: AuthenticatedAdminAdminAiQueriesRoute,AuthenticatedAdminAdminMatrixRoute: AuthenticatedAdminAdminMatrixRoute,AuthenticatedAdminAdminBenzoNewRoute: AuthenticatedAdminAdminBenzoNewRoute,AuthenticatedAdminAdminBlogNewRoute: AuthenticatedAdminAdminBlogNewRoute,AuthenticatedAdminAdminHarmReductionNewRoute: AuthenticatedAdminAdminHarmReductionNewRoute,AuthenticatedAdminAdminMedcanNewRoute: AuthenticatedAdminAdminMedcanNewRoute,AuthenticatedAdminAdminOpioideNewRoute: AuthenticatedAdminAdminOpioideNewRoute,AuthenticatedAdminAdminSourcesNewRoute: AuthenticatedAdminAdminSourcesNewRoute,AuthenticatedAdminAdminSubstancesNewRoute: AuthenticatedAdminAdminSubstancesNewRoute,AuthenticatedAdminAdminSourcesIndexRoute: AuthenticatedAdminAdminSourcesIndexRoute,AuthenticatedAdminAdminBenzoIdEditRoute: AuthenticatedAdminAdminBenzoIdEditRoute,AuthenticatedAdminAdminBlogIdEditRoute: AuthenticatedAdminAdminBlogIdEditRoute,AuthenticatedAdminAdminHarmReductionIdEditRoute: AuthenticatedAdminAdminHarmReductionIdEditRoute,AuthenticatedAdminAdminMedcanIdEditRoute: AuthenticatedAdminAdminMedcanIdEditRoute,AuthenticatedAdminAdminOpioideIdEditRoute: AuthenticatedAdminAdminOpioideIdEditRoute,AuthenticatedAdminAdminSourcesIdEditRoute: AuthenticatedAdminAdminSourcesIdEditRoute,AuthenticatedAdminAdminSubstancesIdEditRoute: AuthenticatedAdminAdminSubstancesIdEditRoute
}

const AuthenticatedAdminAdminRouteWithChildren = AuthenticatedAdminAdminRoute._addFileChildren(AuthenticatedAdminAdminRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAdminRoute: AuthenticatedAdminAdminRouteWithChildren
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,BenzoRoute: BenzoRoute,BlogRoute: BlogRoute,HarmReductionRoute: HarmReductionRoute,MatrixRoute: MatrixRoute,MedcanRoute: MedcanRoute,NotfallRoute: NotfallRoute,OpioideRoute: OpioideRoute,TerpeneRoute: TerpeneRoute,BlogSlugRoute: BlogSlugRoute,HarmReductionSlugRoute: HarmReductionSlugRoute,MatrixPairRoute: MatrixPairRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)